angular.module('impactx.purchaseorder').controller('PurchaseOrderDetailCtrl', [
    '$scope',
    'dataGen',
    '$context',
    '$routeParams',
    '$mdDialog',
    '$mdToast',
    'selectedListItems',
    '$redirect',
    'basketTemplateMenu',
    'OpenGovernmentDataService',
    'ToastService',
    'TranslationService',
    '$route',
    'ToolbarService',
    'CancellationService',
    'AppConfiguration',
    'SubsequentPurchaseOrderDataService',
    'TemplateNameService',
    'LoadingDialogService',
    'ixaPrintService',
    'PurchaseOrderService',
    'EformsHandoffService',
    PurchaseOrderDetailController
]);

function PurchaseOrderDetailController($scope, dataGen, $context, $routeParams, $mdDialog, $mdToast, selectedListItems,
                                       $redirect, basketTemplateMenu, OpenGovernmentDataService, ToastService,
                                       TranslationService, $route, ToolbarService, CancellationService, AppConfiguration,
                                       SubsequentPurchaseOrderDataService, TemplateNameService, LoadingDialogService, ixaPrintService,
                                       PurchaseOrderService, EformsHandoffService) {
    var pohId = 0;
    var self = this;

    $scope.scrollList = [];

    if ($routeParams.id) {
        pohId = $routeParams.id;
    }
    else {
        pohId = selectedListItems.getFirstSelectedId();
    }

    var printId = $routeParams.printId;

    $scope.selectedPurchaseItems = [];

    $scope.selectedPurchaseOrderItems = [];

    $scope.getPageData = function () {
        dataGen.getData($scope, {id: pohId}, "/purchaseorder/view").then(function () {
            $scope.scrollList.push({id: 'timeline', label: $scope.trns.timeline});
            $scope.scrollList.push({id: 'internalComments', label: $scope.trns.internalComments});
            $scope.scrollList.push({id: 'externalComments', label: $scope.trns.externalComments});
            $scope.scrollList.push({id: 'csc', label: $scope.data.poh.contract.value});
            $scope.scrollList.push({id: 'basketSum', label: $scope.trns.sum});

            ToolbarService.setScrollMenu($scope.scrollList);
            defineButtons();

            if (printId) {
                ixaPrintService.print($scope.printTokens[printId]);
            }
        });
    };

    $scope.getPageData();

    $scope.showItemComments = {value: false};
    self.toggleItemComment = function () {
        $scope.showItemComments.value = !$scope.showItemComments.value;
    };

    $scope.showHeaderComment = {value: false};
    self.toggleComment = function () {
        $scope.showHeaderComment.value = !$scope.showHeaderComment.value;
    };

    $scope.showHeaderShare = {value: false};
    self.toggleShare = function () {
        $scope.showHeaderShare.value = !$scope.showHeaderShare.value;
    };

    self.reExport = function () {
        var dataObj = {
            pohId: $scope.data.poh.id
        };
        return dataGen.postAsForm($scope, dataObj, "/purchaseorder/reexport").then(function () {
            $mdToast.show(
                $mdToast.simple()
                    .textContent($scope.trns.reExportSuccess)
                    .position("bottom right")
                    .hideDelay(10000)
            );
        });
    };
    
    self.cancelConditions = function () {
        var dataObj = {
            pohId: $scope.data.poh.id
        };
        return dataGen.postAsForm($scope, dataObj, "/purchaseorder/cancelconditions").then(function () {
            $mdToast.show(
                $mdToast.simple()
                    .textContent($scope.trns.cancelSuccess)
                    .position("bottom right")
                    .hideDelay(10000)
            );
        });
    };
    
    self.cancelMasterConditions = function () {
        var dataObj = {
            pohId: $scope.data.poh.id
        };
        return dataGen.postAsForm($scope, dataObj, "/purchaseorder/cancelmasterconditions").then(function () {
            $mdToast.show(
                $mdToast.simple()
                    .textContent($scope.trns.cancelMasterSuccess)
                    .position("bottom right")
                    .hideDelay(10000)
            );
        });
    };
    
    self.showDeliveryOverdueDialog = function (event) {
        $mdDialog.show({
            controller: "DeliveryOverdueCtrl",
            controllerAs: "deliveryOverdueCtrl",
            templateUrl: "modules/purchaseorder/templates/deliveryoverduedialog.tmpl.html",
            parent: angular.element(document.body),
            targetEvent: event,
            clickOutsideToClose: false,
            locals: {
                deliveryOverdue: $scope.data.poh.deliveryOverdue,
                sendLabel: $scope.trns.send,
                abortLabel: $scope.trns.abort,
                headerLabel: $scope.trns.deliveryOverdue,
                pohId: $scope.data.poh.id,
                requiredLabel: $scope.trns.required
            }
        })
            .then(function () {
                $mdToast.show(
                    $mdToast.simple()
                        .textContent($scope.trns.deliveryOverdueSentSuccessful)
                        .position("bottom right")
                        .hideDelay(10000)
                );
                $scope.getPageData();
            }, function () {
            });
    };
    self.showSentDeliveryOverdue = function (event) {
        $mdDialog.show({
            controller: "SentDeliveryOverdueCtrl",
            controllerAs: "sentDeliveryOverdueCtrl",
            templateUrl: "modules/purchaseorder/templates/sentdeliveryoverduemails.tmpl.html",
            parent: angular.element(document.body),
            targetEvent: event,
            clickOutsideToClose: true,
            locals: {
                sentDeliveryOverdueMails: $scope.data.poh.sentDeliveryOverdueMails,
                abortLabel: $scope.trns.abort,
                headerLabel: $scope.trns.deliveryOverdueMails
            }
        });
    };

    self.newComplaint = function () {
        if ($scope.data.poh.closedDnhIds.length > 0) // just to be sure
        {
            const selected = $scope.selectedPurchaseOrderItems.map((poi)=>poi.id);
            if (AppConfiguration.get("useSimpleComplaint")) {
                if ($scope.data.poh.closedDnhIds.length === 1) {
                    $redirect.redirectTo(null, '/simplecomplaint/0/' + $scope.data.poh.closedDnhIds[0], {poiIds: selected});
                }
                else {
                    $redirect.redirectTo(null, '/simplecomplaint/' + $scope.data.poh.id, {poiIds: selected});
                }
            }
            else {
                if ($scope.data.poh.closedDnhIds.length === 1) {
                    $redirect.redirectTo(null, '/deliverycomplaint/0/' + $scope.data.poh.closedDnhIds[0], {poiIds: selected});
                }
                else {
                    $redirect.redirectTo(null, '/deliverycomplaint/0/0/' + $scope.data.poh.id);
                }
            }
        }
    };

    self.newDeliveryNote = function () {
        if ($scope.data.poh.isDNHAllowed && $scope.selectedPurchaseOrderItems.length === 0) // just to be sure
        {
            $redirect.redirectTo(null, '/deliverynote/' + $scope.data.poh.id)
        }
    };

    self.newDeliveryNoteItems = function () {
        if ($scope.data.poh.isPartialDNHAllowed && $scope.selectedPurchaseOrderItems.length > 0) // just to be sure
        {
            var selected = [];
            for (var i = 0; i < $scope.selectedPurchaseOrderItems.length; i++) {
                selected.push({poiId: $scope.selectedPurchaseOrderItems[i].id});
            }
            $redirect.redirectTo(null, '/deliverynote/' + $scope.data.poh.id, selected)
        }
    };


    self.cancelItems = function (event) {
        var selected = [];
        var ids = [];
        for (var i = 0; i < $scope.selectedPurchaseOrderItems.length; i++) {
            if (ids.indexOf($scope.selectedPurchaseOrderItems[i].id) < 0) {
                ids.push($scope.selectedPurchaseOrderItems[i].id);
                if ($scope.selectedPurchaseOrderItems[i].basketItemGroupId > 0) {
                    self.addItemsOfSameBasketItemGroup(ids, $scope.selectedPurchaseOrderItems[i])
                }
            }
        }
        for (var j = 0; j < ids.length; j++) {
            selected.push({poiId: ids[j]});
        }
        CancellationService.cancelItems(event, selected);
    };

    this.addItemsOfSameBasketItemGroup = function (ids, itemToAdd) {
        angular.forEach($scope.data.poh.purchaseItems, function (item) {
            if (item.basketItemGroupId === itemToAdd.basketItemGroupId) {
                if (ids.indexOf(item.id) < 0) {
                    ids.push(item.id);
                }
            }
        });
    };

    self.cancelAll = function (event) {
        var selected = [];

        angular.forEach($scope.data.poh.purchaseItems, function (item) {
            selected.push({poiId: item.id});
        });

        CancellationService.cancelAll(event, selected);
    };

    this.createBasketTemplate = function() {
        TemplateNameService.showTemplateName([{pohId: pohId}], '/basket/template/beforecreatefromorder', event).then(function(answer){
            if(answer)
            {
                dataGen.postAsForm({},{items: [{pohId: pohId}], name: answer}, '/basket/template/createfromorder').then(function ()
                {
                    basketTemplateMenu.refreshAllTemplates();
                });
            }
        });
    }


    self.openOpenGovernmentDialog = function (event) {
        var ogdId = impactX.isDefined($scope, 'data.poh.ogdId');
        if (ogdId) {
            OpenGovernmentDataService.openReadOnlyDialog(event, ogdId, $scope.data.poh.orderNumber.value);
        }
    };

    /*
     * Jumps off to the eForms handoff page. Delegates to the shared service and, if the popup blocker
     * swallowed the window, that is reported instead of pretending the announcement happened.
     */
    self.announceEForms = function () {
        EformsHandoffService.openHandoff($scope.data.poh.id);
    };

    self.reportOpenGovernmentData = function (event) {
        return dataGen.getData({}, {pohId: $scope.data.poh.id}, "/opengovernmentdata/purchaseorder/check").then(function (rsp) {
            if(rsp && rsp.data)
            {
                if(!rsp.data.noInfo)
                {
                    $mdDialog.show({
                        controller: 'OpenGovernmentDataOverdueDialogCtrl',
                        controllerAs: 'ctrl',
                        locals: {
                            pohId: $scope.data.poh.id
                        },
                        templateUrl: 'modules/opengovernmentdata/templates/opengovernmentoverdue.dialog.html',
                        parent: angular.element(document.body),
                        bindToController: true,
                        targetEvent: event,
                        data: rsp.data,
                        trns: rsp.trns
                    }).then(function () {
                        OpenGovernmentDataService.openEditDialogWithWarnings(pohId)
                    });
                }
                else
                {
                    OpenGovernmentDataService.openEditDialogWithWarnings(pohId)
                }
            }
        })
    };

    self.formatAddressValue = function (value) {
        if(value) {
            return value.replace(/,\s/g, '<br/>')
        }
        return '';
    }

    $scope.showBuyerNoMinimizedBasket = AppConfiguration.get('showBuyerNoMinimizedBasket');

    self.toggleMinimized = function () {
        $scope.data.poh.minimized = !$scope.data.poh.minimized;
        dataGen.postAsForm({}, {minimized: $scope.data.poh.minimized}, "/purchaseorder/saveminimized").then(
            angular.noop,
            function () {
                $scope.data.poh.minimized = !$scope.data.poh.minimized;
            }
        );
    };

    self.isMinimized = function () {
        return !!$scope.data.poh.minimized;
    };

    self.isNotMinimized = function () {
        return !$scope.data.poh.minimized;
    };

    self.canJumpToCancelRequest = function () {
        return $scope.data.poh.crhId > 0;
    };

    self.getCancelRequestLink = function () {
        return "crhdetails/" + $scope.data.poh.crhId;
    };

    function defineButtons() {
        if ($scope.data.poh.noActions) {
            ToolbarService.setButtons([{
                label: $scope.trns.print,
                type: 'print',
                params: {
                    printToken: $scope.printTokens.order,
                }
            }]);
        }
        else {
            var buttonDefinition = [
                {
                    icon: 'mdi-arrow-collapse-vertical',
                    iconClass: 'icon-button-margin-adjust',
                    tooltip: $scope.trns.minimize,
                    type: 'icon',
                    action: self.toggleMinimized,
                    condition: self.isNotMinimized
                },
                {
                    icon: 'mdi-arrow-expand-vertical',
                    iconClass: 'icon-button-margin-adjust',
                    tooltip: $scope.trns.expand,
                    type: 'icon',
                    action: self.toggleMinimized,
                    condition: self.isMinimized
                },
                {
                    label: $scope.trns.cancelRequest,
                    linkFunction: self.getCancelRequestLink,
                    type: 'link',
                    condition: self.canJumpToCancelRequest
                },
                {
                    label: $scope.trns.comment,
                    action: self.toggleComment,
                    type: 'dialogaction',
                    condition: canToggleHeaderComment
                },
                {
                    label: $scope.trns.comment,
                    action: self.toggleItemComment,
                    type: 'dialogaction',
                    condition: canToggleItemComment
                },
                {
                    label: $scope.trns.createDelNote,
                    action: self.newDeliveryNote,
                    type: 'dialogaction',
                    condition: canCreateDeliveryNote
                },
                {
                    label: $scope.trns.createDelNote,
                    action: self.newDeliveryNoteItems,
                    type: 'dialogaction',
                    condition: canCreateDeliveryNoteItems
                },
                {
                    label: $scope.trns.newComplaint,
                    action: self.newComplaint,
                    type: 'dialogaction',
                    condition: canCreateComplaint
                },
                {
                    label: $scope.trns.changeDeliveryTime,
                    action: self.openChangeDeliveryTimeDialog,
                    type: 'dialogaction',
                    condition: canChangeDeliveryTime
                },
                {
                    label: $scope.trns.reExport,
                    action: self.reExport,
                    type: 'dialogaction',
                    condition: canReExport
                },
                {
                    label: $scope.trns.deliveryOverdue,
                    action: self.showDeliveryOverdueDialog,
                    type: 'dialogaction',
                    condition: canDeliveryOverdue
                },
                {
                    label: $scope.trns.deliveryOverdueMails,
                    action: self.showSentDeliveryOverdue,
                    type: 'dialogaction',
                    condition: canSendDeliveryOverdue
                },
                {
                    label: $scope.trns.cancel,
                    action: self.cancelItems,
                    type: 'dialogaction',
                    condition: canCancelItem
                },
                {
                    label: $scope.trns.cancelAll,
                    action: self.cancelAll,
                    type: 'dialogaction',
                    condition: canCancel
                },
                {
                    label: $scope.trns.closeInvoice,
                    action: self.closeInvoice,
                    type: 'dialogaction',
                    condition: canCloseInvoice
                },
                {
                    label: $scope.trns.reopenInvoice,
                    action: self.reopenInvoice,
                    type: 'dialogaction',
                    condition: canReopenInvoice
                },
                {
                    label: $scope.trns.createOGD,
                    action: self.reportOpenGovernmentData,
                    type: 'dialogaction',
                    condition: canReportOGD
                },
                {
                    label: $scope.trns.announceEForms,
                    action: self.announceEForms,
                    type: 'dialogaction',
                    condition: canAnnounceEForms
                },
                {
                    label: $scope.trns.createTemplate,
                    action: self.createBasketTemplate,
                    type: 'dialogaction',
                    condition: canCreateTemplate
                },
                {
                    label: $scope.trns.print,
                    type: 'print',
                    params: {
                        printToken: $scope.printTokens.order,
                    }
                },
                {
                    label: $scope.trns.shareStatusButton,
                    action: self.toggleShare,
                    type: 'dialogaction',
                    condition: canToggleShare
                },
                {
                    label: $scope.trns.editSPO,
                    action: self.editSPO,
                    type: 'dialogaction',
                    condition: self.canOnlyEditSPO
                },
                {
                    label: $scope.trns.cancelConditions,
                    action: self.cancelConditions,
                    type: 'dialogaction',
                    condition: allowConditionCancellation
                },
                {
                    label: $scope.trns.cancelMasterConditions,
                    action: self.cancelMasterConditions,
                    type: 'dialogaction',
                    condition: allowConditionMasterCancellation
                },
                {
                    label: $scope.trns.modifyOrder,
                    action: self.modifyOrder,
                    type: 'action',
                    condition: canModifyOrder
                }
            ];
            ToolbarService.setButtons(buttonDefinition);
        }
    }

    function canModifyOrder() {
        return $scope.data.poh.canModifyOrder === true;
    }

    self.modifyOrder = function() {
        return dataGen.postAsForm($scope, { pohId: $scope.data.poh.id }, '/purchaseorder/loadintobasket')
            .then(function(result) {
                $context.refreshBasket({}, dataGen, $context);
                $redirect.redirectTo(null, '/basket/' + result.data.basketId);
            });
    };

    self.openChangeDeliveryTimeDialog = function (event) {
        PurchaseOrderService.showChangeDeliveryTimeDialog(event, $scope.data.poh.id).then(function () {
            $route.reload();
            ToastService.openStandardToast(TranslationService.get("saveSuccess"));
        }, angular.noop);
    }

    function canChangeDeliveryTime() {
        return $scope.data.poh.canChangeDeliveryTime;
    }

    self.canOnlyEditSPO = function () {
        //should normally be false, but just to make sure..
        return self.canEditSPO() && !$scope.data.poh.canShowSubsequentPurchaseOrderData;
    }

    self.canEditSPO = function () {
        return $scope.data && $scope.data.poh.canEditSPO;
    }

    self.openSubsequentPurchaseOrderDataDialog = function (event) {
        if (self.canEditSPO()) {
            self.editSPO(event)
        }
        else {
            SubsequentPurchaseOrderDataService.openViewDialog(event, 0, 0, $scope.data.poh.id);
        }
    };

    self.editSPO = function (event) {
        SubsequentPurchaseOrderDataService.openEditDialog(event, $scope.data.poh.id, "poh");
    };

    function canToggleHeaderComment() {
        return !isSupplier() && hasNoItemsSelected();
    }

    function canToggleShare() {
        return !isSupplier() && hasNoItemsSelected() && AppConfiguration.get("useShareOrderStatus");
    }

    function canToggleItemComment() {
        return !isSupplier() && !hasNoItemsSelected();
    }

    function canCreateDeliveryNote() {
        return $scope.data.poh.isDNHAllowed && hasNoItemsSelected();
    }

    function canCreateDeliveryNoteItems() {
        return $scope.data.poh.isPartialDNHAllowed && !hasNoItemsSelected();
    }

    function canCreateComplaint() {
        return $scope.data.poh.canComplain;
    }

    function canReExport() {
        return !isSupplier() && hasNoItemsSelected() && !$scope.data.poh.readOnly && $scope.data.poh.canReExport;
    }
    
    function allowConditionCancellation() {
        return !isSupplier() && $scope.data.poh.allowConditionCancellation;
    }
    
    function allowConditionMasterCancellation() {
        return !isSupplier() && $scope.data.poh.allowConditionMasterCancellation;
    }

    function canDeliveryOverdue() {
        return !isSupplier() && hasNoItemsSelected() > 0 && !$scope.data.poh.readOnly && $scope.data.poh.overdueEnabled;
    }

    function canSendDeliveryOverdue() {
        return !isSupplier() && hasNoItemsSelected() && $scope.data.poh.sentDeliveryOverdueMails.length > 0;
    }

    function canCancelItem() {
        return canCancel() && !hasNoItemsSelected();
    }

    function canCancel() {
        return $scope.data.poh.canCancel;
    }

    function canCloseInvoice() {
        return $scope.data.poh.canCloseInvoice;
    }

    function canReopenInvoice() {
        return $scope.data.poh.canReopenInvoice;
    }

    function canReportOGD() {
        return $scope.data.poh.canReportOGD;
    }

    /*
     * The backend already answers "may this user announce the contract award of THIS order" -- it
     * folds the active eForms service, the contract type and the permission into one flag. There is
     * deliberately no second rule here; the client carries no business logic.
     * Mirrors canAnnounceEForms() of the Angular PurchaseOrderDetailComponent.
     */
    function canAnnounceEForms() {
        return $scope.data.poh.canAnnounceEForms === true;
    }

    function canCreateTemplate() {
        return $scope.data.poh.canCreateTemplate;
    }

    function isSupplier() {
        return $scope.isSupplier && $scope.isSupplier.value;
    }

    function hasNoItemsSelected() {
        return !$scope.selectedPurchaseOrderItems.length;
    }

    this.addStatusEmailAddress = function (emailValue) {
        LoadingDialogService.start();
        var dataObj = {
            id: $scope.data.poh.id,
            mail: emailValue
        };
        dataGen.postAsForm({}, dataObj, '/purchaseorder/statusmailaddress/add').then(function () {
                LoadingDialogService.stop();
                ToastService.openStandardToast(TranslationService.get("saveSuccess"));
            },
            function () {
                LoadingDialogService.stop();
                $scope.data.poh.statusEMailAddresses.pop();
            });
    }

    this.deleteStatusEmailAddress = function (emailValue) {
        LoadingDialogService.start();
        var dataObj = {
            id: $scope.data.poh.id,
            mail: emailValue
        };
        dataGen.postAsForm({}, dataObj, '/purchaseorder/statusmailaddress/delete').then(function () {
                LoadingDialogService.stop();
                ToastService.openStandardToast(TranslationService.get("saveSuccess"));
            },
            function () {
                LoadingDialogService.stop();
                $scope.data.poh.statusEMailAddresses.push(emailValue);
            });
    }
}